import {
    ADD_TO_CART,
    PURCHASE_CD,
    DOWNLOAD,
    NOT_AVAILABLE_IN_SITE,
    DISCONTINUED,
} from './availabilityOptions';

const shouldItBe = (condition, template) => (condition ? template() : '');

function downloadButtonTemplate(props) {
    if (!props.downloads || props.downloads.length === 0) return '';
    const onlyOne = props.downloads.length === 1;
    const { link, fileName } = props.downloads[0];
    const linkFilename = fileName || '';
    return `
        <div class="download-block-wrapper">
            <div class="sticky-wrapper">
                <div id="download_btn__background" ${!onlyOne ? 'class="has-option-download"' : ''}>
                    <a ${
                        onlyOne ? `href="${link}${linkFilename}" download` : ''
                    } class="product-description__download_btn btn-se btn-se_full-width btn-se_color_blue btn-se_size_m">
                        ${props.msgDownloadLabel}
                    </a>
                </div>
            </div>
        </div>
    `;
}

function howToBuyTemplate(props) {
    return `
        <div class="how-to-buy-block-wrapper">
            <div class="sticky-wrapper">
                <div class="how-to-buy">
                    <a id="how-to-buy" target="_blank" class="how-to-buy__button"  rel="noreferrer noopener nofollow" href="${
                        props.homeLink
                    }how-to-buy/index.jsp">
                        <span class="how-to-buy__tooltip"></span>
                        <span>${props.howToBuy}</span>
                    </a>
                </div>
            </div>
        </div>
    `;
}

function priceBlockFormTemplate(props) {
    const isPurchaseClass = props.availability === PURCHASE_CD ? 'purchase_button' : '';
    return `
    <form id="pdp_form">
        <div class="product-description__price-section-quantity-counter-wrapper">
            ${shouldItBe(
                props.prices.previousPrice,
                () => `<div class="crossed-out-price-label">${props.prices.previousPrice}</div>`
            )}

            <div class="price-label">${props.prices.activePrice}</div>
            ${shouldItBe(
                props.prices.VATInclused,
                () => `<div class="vat-price-label">${props.priceWithVat}</div>`
            )}
            ${shouldItBe(
                props.prices.priceLabel,
                () => `<div class="reseller-price-label">${props.prices.priceLabel}</div>`
            )}
            ${shouldItBe(
                (props.availability === ADD_TO_CART || props.availability === PURCHASE_CD) &&
                    !(props.substitution || '').showButton,
                () => `
                    <div class="product-description__quantity-counter">
                        <button
                            class="product-description__quantity-counter-btn btn-se btn-se_align_center"
                            id="btn-counter-dec"
                            type="button"
                            disabled
                        >
                            <span class="product-description__quantity-counter-btn-symbol">
                                <svg class="icon icon_minus "><use xlink:href="#minus"></use></svg>
                            </span>
                        </button>
                        <input id="qty_field" value="1" class="product-description__quantity-counter-input" type="text" value="1" />
                        <button
                            class="product-description__quantity-counter-btn btn-se btn-se_align_center"
                            id="btn-counter-inc"
                            type="button"
                        >
                            <span class="product-description__quantity-counter-btn-symbol">
                                <svg class="icon icon_plus"><use xlink:href="#plus"></use></svg>
                            </span>
                        </button>
                        <div class="product-description__quantity-counter-validation-error hidden">
                            <span class="product-description__quantity-counter-validation-error-message"></span>
                        </div>
                    </div>
            `
            )}
        </div>
            ${shouldItBe(
                (props.availability === ADD_TO_CART || props.availability === PURCHASE_CD) &&
                    !(props.substitution || '').showButton,
                () => `
                <div class="sticky-wrapper">
                    <div id="add-to-cart__background">
                        <div>
                            <input type="button" value="${
                                props.availability === ADD_TO_CART
                                    ? props.msgAddToCartText
                                    : props.msgPurchaseCdLabel
                            }" class="product-description__add-to-cart-btn btn-se btn-se_full-width btn-se_color_blue btn-se_size_m btn_loading ${isPurchaseClass}" id="add-to-cart" />
                        </div>
                    </div>
                </div>
            `
            )}

        </div>
    </form>
    `;
}

function priceBlockTemplate(props) {
    const pathName =  window.location.pathname.split('/')[2];
    return `
    <div class="product-description__price-section-cart-wrapper">
        ${shouldItBe(
            props.availability === ADD_TO_CART &&
                !(props.substitution || '').showSubstitutionLabel &&
                !(props.substitution || '').showButton &&
                pathName !== 'au',
            () => `<h5 class="product-description__stock-section">${props.msgInStock}</h5>`
        )}
        ${shouldItBe(
            props.substitution && props.substitution.showSubstitutionLabel,
            () =>
                `<h5 class="product-description__stock-has-substitute">${
                    props.substTemporarilyUnavailableLabel
                }</h5>`
        )}

        ${shouldItBe(props.prices !== null, () => priceBlockFormTemplate(props))}

    </div>`;
}

function discontinuedTemplate(props) {
    return `
        ${shouldItBe(
            props.availability === DISCONTINUED || props.availability === NOT_AVAILABLE_IN_SITE,
            () => `
            <div class="product-description__discounted-section">
                ${shouldItBe(
                    props.availability === DISCONTINUED,
                    () => `<span class="product-description__discounted-section__icon">
                        <svg class="icon icon_attention"><use xlink:href="#attention_rounded"></use></svg>
                        <span class="product-description__discounted-section__text">${
                            props.msgDiscontinued
                        }</span>
                    </span>`
                )}
                ${shouldItBe(
                    props.availability === NOT_AVAILABLE_IN_SITE,
                    () =>
                        `<span class="product-description__discounted-section__text">${
                            props.msgNotAvailableInSite
                        }</span>`
                )}
            </div>

        `
        )}
        ${shouldItBe(
            props.howToBuyShowing &&
                props.downloads === undefined &&
                !(props.substitution || '').showButton,
            () => howToBuyTemplate(props)
        )}
    `;
}

function addToFavoritesTemplate(props) {
    let stateClass;
    let stateText;
    if (props.loggedUser && props.giftId) {
        stateClass = 'add_to_favourites_state_added';
        stateText = props.remove_title;
    } else {
        stateClass = '';
        stateText = props.add_title;
    }
    return `
        <div class="product-description__add-to-favorites-section btn-se btn-se_full-width btn-se_size_m ${stateClass}"
            data-giftlist_id="${props.giftListId || ''}"
            data-gift_id="${props.giftId || ''}"
            data-logged_user=${props.loggedUser}
            data-add_wish_notification=${props.showAddingNotification}>
            <button class="product-description__add-to-favorites-text" id="add_to_favourites">
                <svg id="add_to_favourites_svg" width="100%" height="100%" viewBox="-1 -1 17 17" preserveAspectRatio="xMidYMid meet">
                <g></g>
                <path d="M15,5.81285444 C15,5.95148147 14.9218758,6.1027087 14.765625,6.26654064 L11.4933894,9.61247637 L12.2686298,14.3383743 C12.2746395,14.3824829 12.2776442,14.4454942 12.2776442,14.5274102 C12.2776442,14.659736 12.2460941,14.7715811 12.1829928,14.862949 C12.1198915,14.9543168 12.0282458,15 11.9080529,15 C11.7938696,15 11.6736785,14.9621932 11.547476,14.8865784 L7.5,12.6559546 L3.45252404,14.8865784 C3.32031184,14.9621932 3.20012073,15 3.09194712,15 C2.96574456,15 2.87109407,14.9543168 2.80799279,14.862949 C2.74489151,14.7715811 2.71334135,14.659736 2.71334135,14.5274102 C2.71334135,14.4896028 2.7193509,14.4265915 2.73137019,14.3383743 L3.50661058,9.61247637 L0.225360577,6.26654064 C0.0751194411,6.09640747 0,5.94518025 0,5.81285444 C0,5.57970898 0.168267548,5.43478289 0.504807692,5.37807183 L5.03004808,4.68809074 L7.05829327,0.387523629 C7.17247653,0.129173251 7.31971064,0 7.5,0 C7.68028936,0 7.82752347,0.129173251 7.94170673,0.387523629 L9.96995192,4.68809074 L14.4951923,5.37807183 C14.8317325,5.43478289 15,5.57970898 15,5.81285444 Z"></path>
                </svg><span>${stateText}</span>
            </button>
        </div>
    `;
}

export function substituteBlock(props) {
    return `
        <div class="product-description__substitute-block">
            <div class="product-description__substitute-header">${
                props.substRecommendedAlternativeLabel
            }</div>
            <div class="product-description__substitute-body">
                <div class="product-description__substitute-image" style="background-image:url(${
                    props.substitution.substitutionInfo.imageUrl
                })"></div>
                <div class="product-description__substitute-text">${
                    props.substitution.substitutionInfo.name
                }</div>
            </div>
            <div class="substitute-block-wrapper">
                <div class="sticky-wrapper">
                    <div id="substitute_btn__background">
                        <a href=${
                            props.substitution.substitutionInfo.url
                        } class="product-description__substitute_btn btn-se btn-se_full-width btn-se_color_blue btn-se_size_m">
                            ${props.substViewAlternativeLabel}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `;
}

export function renderBlock(props) {
    const { availability, addToFavoritesInfo, add_title, remove_title } = props;
    return `
        ${shouldItBe(
            availability !== DISCONTINUED &&
                availability !== NOT_AVAILABLE_IN_SITE &&
                (props.prices !== null ||
                    (props.substitution && props.substitution.showSubstitutionLabel)),
            () => priceBlockTemplate(props)
        )}
        ${shouldItBe(
            availability === DOWNLOAD ||
                availability === DISCONTINUED ||
                availability === NOT_AVAILABLE_IN_SITE,
            () => downloadButtonTemplate(props)
        )}
        <div class="product-description__price-section-discontinued-wrapper">
            ${discontinuedTemplate(props)}
        </div>
        ${shouldItBe(addToFavoritesInfo && availability !== DISCONTINUED, () =>
            addToFavoritesTemplate({ ...addToFavoritesInfo, add_title, remove_title })
        )}
    `;
}
